import { apiClient } from './client';

export interface TelegramDialog {
  conversation_id: string;
  client_id: string | null;
  client_name: string | null;
  channel_user_id: string;
  username: string | null;
  conversation_status: string;
  order_id: string | null;
  order_status: string | null;
  occasion: string | null;
  mood: string | null;
  flow_step: string | null;
  message_count: number;
  last_message_at: string | null;
  created_at: string | null;
}

export interface TelegramStats {
  total_dialogs: number;
  active_flows: number;
  dialogs_with_orders: number;
  dialogs_without_orders: number;
  conversion_rate: number;
}

interface TelegramDialogsResponse {
  success: boolean;
  data: TelegramDialog[];
  total: number;
  page: number;
  per_page: number;
  pages: number;
}

interface TelegramStatsResponse {
  success: boolean;
  data: TelegramStats;
}

export interface TelegramDialogFilters {
  page?: number;
  per_page?: number;
  order_status?: string;
  has_order?: boolean;
  search?: string;
}

export const telegramApi = {
  getDialogs: async (params: TelegramDialogFilters = {}): Promise<TelegramDialogsResponse> => {
    const response = await apiClient.get<TelegramDialogsResponse>(
      '/admin/telegram/dialogs',
      { params }
    );
    return response.data;
  },

  getStats: async (): Promise<TelegramStats> => {
    const response = await apiClient.get<TelegramStatsResponse>(
      '/admin/telegram/stats'
    );
    return response.data.data;
  },
};
